import type { CollectorSummary } from '../types';

export type BannerSeverity = 'banned' | 'error' | 'warning' | 'info';

export type BannerState = {
  severity: BannerSeverity;
  message: string;
  dismissable: boolean;
};

export type BannerInput = {
  summary: CollectorSummary;
};

function bannedState(): BannerState {
  return {
    severity: 'banned',
    message:
      'Tu cuenta está cerrada. Tu pago final se liquidará el próximo lunes.',
    dismissable: false,
  };
}

function errorState(): BannerState {
  return {
    severity: 'error',
    message:
      'Algo no está funcionando bien con tus pagos. Contáctanos en @debook.app para que lo revisemos.',
    dismissable: true,
  };
}

function warningState(): BannerState {
  return {
    severity: 'warning',
    message:
      'Estamos verificando algunos cálculos. Si ves algo raro, escríbenos a @debook.app.',
    dismissable: true,
  };
}

export function pickBannerState({ summary }: BannerInput): BannerState | null {
  if (summary.account_status === 'banned') return bannedState();
  if (summary.system_health === 'error') return errorState();
  if (summary.system_health === 'warning') return warningState();
  return null;
}
